var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#D2D2D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6672 8.34414C22.2235 7.90046 21.5068 7.90046 21.0631 8.34414L15.5 13.8959L9.93686 8.33276C9.49317 7.88908 8.77645 7.88908 8.33276 8.33276C7.88908 8.77645 7.88908 9.49317 8.33276 9.93686L13.8959 15.5L8.33276 21.0631C7.88908 21.5068 7.88908 22.2235 8.33276 22.6672C8.77645 23.1109 9.49317 23.1109 9.93686 22.6672L15.5 17.1041L21.0631 22.6672C21.5068 23.1109 22.2235 23.1109 22.6672 22.6672C23.1109 22.2235 23.1109 21.5068 22.6672 21.0631L17.1041 15.5L22.6672 9.93686C23.0995 9.50455 23.0995 8.77645 22.6672 8.34414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.c0794c8ec05b022df2322eedaee2fbea.svg";
export { ForwardRef as ReactComponent };